module.exports = __webpack_public_path__ + "images/services/fogbugz.c55a2bc4b36ff1cfd746.png";